import { createContainer } from "unstated-next";
import { useState } from "react";
function useSelectMode() {
    var _a = useState(false), selecting = _a[0], setSelecting = _a[1];
    var toggle = function () {
        setSelecting(!selecting);
    };
    return { toggle: toggle, selecting: selecting };
}
export var SelectModeContainer = createContainer(useSelectMode);
//# sourceMappingURL=select-mode.js.map